import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useBridgeContext } from '@sendible/shared-state-bridge';
import { EVENTS, publish } from '@sendible/event-manager';
import { routeUtils } from '@sendible/common';
import { PageBaseKeys, getRoutes } from '../../routes';

export const ProtectedRoutes = () => {
  const [
    {
      user: { canNavigate, featureTags },
    },
  ] = useBridgeContext();
  const { pathname } = useLocation();
  const pathWihtoutSubPaths = routeUtils.getPathWithoutSubPaths(pathname);
  const availableFeatureTagsArray = Object.keys(featureTags);
  const currentRoutes = getRoutes();
  const routeConfigObject = currentRoutes[pathWihtoutSubPaths as PageBaseKeys] ? currentRoutes[pathWihtoutSubPaths as PageBaseKeys] : null;
  const routeFeatureTagName = routeConfigObject?.featureTag;
  const routeFeautreRestrictionName = routeConfigObject?.featureRestriction;
  let featureIsRestricted = false;

  if (routeFeautreRestrictionName) {
    const featureStatus = window.js_featurMngr.getFeatureStatus(routeFeautreRestrictionName);

    featureIsRestricted = featureStatus == 'restricted' || featureStatus == 'limited';
  }

  // Compute the restriction status safely during render
  const isRestricted = !canNavigate || featureIsRestricted;

  // Isolate the pub/sub navigation side-effect into an effect hook
  useEffect(() => {
    if (isRestricted) {
      publish(EVENTS.CHANGE_PAGE, '/#manage/subscription');
    }
  }, [isRestricted]);

  if (isRestricted) {
    // Return null or a skeleton/spinner while the effect kicks off the redirect
    return null;
  }

  if (!routeFeatureTagName || (routeFeatureTagName && availableFeatureTagsArray.indexOf(routeFeatureTagName) > -1)) {
    return <Outlet />;
  }

  return <Navigate to="/#publish" />;
};
